module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "browse-season"
  }, [_c('h3', [_vm._v(_vm._s(_vm.season.title))]), _vm._v(" "), _c('ul', _vm._l((_vm.season.episodes), function(episode) {
    return _c('li', {
      key: episode.airedEpisodeNumber
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: ("/Browse/Season/" + (_vm.season.airedSeason) + "/Episode/" + (episode.airedEpisodeNumber))
        }
      }
    }, [_vm._v("\n        E" + _vm._s(episode.airedEpisodeNumber) + " - "), _c('strong', [_vm._v(_vm._s(episode.episodeName))])])], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bd571c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BrowseSeason.vue
// module id = 39
// module chunks = 0